import { FC } from 'react';
import { Link } from 'react-router-dom';
import { VStack } from '@chakra-ui/react';

import OfferCard from 'features/Insurance/components/OfferCard';
import { useNewInsuranceCoverage } from 'features/Insurance/hooks/useNewInsuranceCoverage';
import offers from 'features/Insurance/offers';
import Upgrade from 'features/Insurance/pages/Coverage/components/Upgrade';
import { InsuranceGroup } from 'features/Insurance/pages/NewCoverage/components/InsuranceGroup';
import * as Layout from 'layouts/OffersLayout';

import locales from './locales';

export const NewCoverage: FC = () => {
  const { coveredInsurancesCount, groups, uncoveredInsurancesCount } =
    useNewInsuranceCoverage();

  return (
    <Layout.PageContainer
      trackViewProps={{
        pageName: 'NewInsurancesOffers Viewed',
        usePrefix: false,
      }}
    >
      <Layout.PageTitle
        description={locales.description}
        title={locales.title}
      />

      {coveredInsurancesCount === 0 ? (
        <>
          <Upgrade paddingBottom="space-48" paddingX="space-80" />
          <Layout.ListTitle
            count={uncoveredInsurancesCount}
            title={locales.categories.noCoverage}
          />

          <VStack alignItems="stretch" gap="space-24">
            {[...groups.entries()].map(([group, groupItem]) => (
              <InsuranceGroup group={groupItem} key={group} />
            ))}
          </VStack>
        </>
      ) : (
        <>
          <Layout.ListTitle
            count={coveredInsurancesCount}
            title={locales.categories.active}
          />

          <VStack alignItems="stretch" gap="space-24">
            {[...groups.entries()].map(([group, groupItem]) => (
              <InsuranceGroup group={groupItem} key={group} />
            ))}
          </VStack>
        </>
      )}

      <Layout.ListTitle
        marginTop="space-32"
        title={locales.categories.complete}
      />

      <Layout.ListGrid>
        <OfferCard
          as={Link}
          key={offers.fromPartners.path.pathname}
          offer={offers.fromPartners}
          to={{ ...offers.fromPartners.path, state: { from: 'all-offers' } }}
        />
      </Layout.ListGrid>
    </Layout.PageContainer>
  );
};
